import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CodebaseAboutSidebar } from '@/components/CodebaseView/CodebaseAboutSidebar';
import { AssetSettings } from '@/components/Settings/AssetSettings';
import { SettingsHeader } from '@/components/Settings/SettingsHeader';
import { useCodebase } from '@/contexts/CodebaseContext';
import { SourceOverviewProvider } from '@/contexts/SourceOverviewContext';
import { searchParam } from '@/utils/router';

const treeSearchSchema = z.object({
  branchId: searchParam().optional(),
  versionId: searchParam().optional(),
});

export const Route = createFileRoute('/$organizationName/cb/$codebaseId/settings/general')({
  component: CodebaseSettingsGeneralPage,
  validateSearch: treeSearchSchema,
});

function CodebaseSettingsGeneralPage() {
  const { codebaseId, organizationName } = Route.useParams();
  const { codebase } = useCodebase();

  const isAssetAdmin = codebase?.effective_role === 'asset_admin';

  return (
    <SourceOverviewProvider>
      <CodebaseAboutSidebar />
      <SettingsHeader newHeader title="Codebase Settings" />

      <AssetSettings
        // Fill the (already width-capped) column so the cards line up with the
        // "Codebase Settings" heading instead of centering inside it.
        className="mx-0 max-w-none"
        showManagePermissionsButton
        assetId={codebaseId}
        assetName="Codebase"
        isAssetAdmin={isAssetAdmin}
        deleteMessage="Once you remove this codebase from Driver, there is no going back. You will need to reconnect and regenerate all documentation. Please be certain."
        backTo="/$organizationName/library"
        backParams={{ organizationName: organizationName }}
      />
    </SourceOverviewProvider>
  );
}
